
const STORAGE_KEY = "cybros-theme-mode";

function getStoredMode() {
	// Default to "dark" so the Cybros branding is visible on first visit
	// (no localStorage) regardless of OS preference. Users can switch via
	// the theme toggle; their preference is then stored and respected.
	let mode = localStorage.getItem(STORAGE_KEY) || "dark";
	if (mode !== "light" && mode !== "dark" && mode !== "automatic") {
		mode = "dark";
	}
	return mode;
}

function resolveEffectiveTheme(mode) {
	if (mode === "automatic") {
		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
	}
	return mode;
}

function applyDocumentTheme() {
	const mode = getStoredMode();
	const effective = resolveEffectiveTheme(mode);
	document.documentElement.setAttribute("data-theme-mode", mode);
	document.documentElement.setAttribute("data-theme", effective);
	if (window.CybrosLogoTheme && typeof window.CybrosLogoTheme.sync === "function") {
		window.CybrosLogoTheme.sync();
	}
}

function bindSystemPreference() {
	window
		.matchMedia("(prefers-color-scheme: dark)")
		.addEventListener("change", () => {
			if (getStoredMode() === "automatic") {
				applyDocumentTheme();
			}
		});
}

function mountToggle() {
	if (document.querySelector(".cybros-theme-toggle")) {
		return;
	}
	const root = document.createElement("div");
	root.className = "cybros-theme-toggle";
	root.setAttribute("role", "group");
	root.setAttribute("aria-label", "Theme");

	const label = document.createElement("div");
	label.className = "cybros-theme-toggle-label";
	label.textContent = "Theme";
	root.appendChild(label);

	const modes = [
		["light", "Light"],
		["dark", "Dark"],
		["automatic", "Auto"],
	];

	for (const [value, text] of modes) {
		const btn = document.createElement("button");
		btn.type = "button";
		btn.textContent = text;
		btn.dataset.mode = value;
		btn.setAttribute("aria-pressed", getStoredMode() === value ? "true" : "false");
		btn.addEventListener("click", () => {
			localStorage.setItem(STORAGE_KEY, value);
			applyDocumentTheme();
			root.querySelectorAll("button").forEach((b) => {
				b.setAttribute("aria-pressed", b.dataset.mode === value ? "true" : "false");
			});
		});
		root.appendChild(btn);
	}

	document.body.appendChild(root);
}

applyDocumentTheme();
bindSystemPreference();

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", mountToggle);
} else {
	mountToggle();
}

window.CybrosTheme = {
	setMode(mode) {
		if (mode === "light" || mode === "dark" || mode === "automatic") {
			localStorage.setItem(STORAGE_KEY, mode);
			applyDocumentTheme();
		}
	},
	getMode: getStoredMode,
	apply: applyDocumentTheme,
};
